export default function ResultHeaderCell({children, style, scrollable, ...props}) {

    return (
        <th
            style={{
                backgroundColor: '#f0f2f5',
                border: '1px solid #e0e0e0',
                padding: 2,
                paddingLeft: 4,
                paddingRight: 4,
                textAlign: 'center',
                position: scrollable ? 'sticky' : '',
                top: scrollable?.top || 0,
                ...(style ? style : {}),
            }}
            {...props}
        >
            {children}
        </th>
    );
}